import type { ProductOptionState } from '../../type/common.type';

/**
 * 현재 드롭다운 인덱스가 해당 그룹의 마지막 인덱스인지 확인합니다
 * @param state - ProductOption 상태
 * @param group_index - 그룹 인덱스
 * @param dropdown_index - 드롭다운 인덱스
 * @returns 마지막 드롭다운 여부
 */
export const isLastDropdownInGroup = (
  state: ProductOptionState,
  group_index: number,
  dropdown_index: number,
): boolean => {
  const group = state.dropdown_states[group_index];
  if (!group) return false;

  return group.length - 1 === dropdown_index;
};
